import EmpDash from '../Employee/EmpDash';
import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import DashCards from '../Common/DashCards';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Select from "react-select";
import { setActiveDashToggle } from './AllTaskSlice';
import { HrAllDashboard } from '../HR/HrAllDashboard';
import { axiosApi } from '../utils/axiosApi';
import ScatterChart from '../Charts/NewCharts/ScatterChart';
import StackerChart from '../Charts/NewCharts/StackerChart';
import ComboChart from '../Charts/NewCharts/ComboChart';
import RaddarChart from '../Charts/NewCharts/RaddarChart';
import SankeyChart from '../Charts/NewCharts/SankeyChart';
import TreeMapChart from '../Charts/NewCharts/TreeMapChart';
import BarChart from '../Charts/NewCharts/BarChart';
import LineChart from '../Charts/NewCharts/LineChart';
import HeatMapChart from '../Charts/NewCharts/HeatMapChart';
import AreaChart from '../Charts/NewCharts/AreaChart';
import HorizontalBarChart from '../Charts/NewCharts/HorizontalBarChart';
import GaugeChart from '../Charts/NewCharts/GaugeChart';
import EChartBarComponent from '../Charts/NewCharts/EchartBarComponent';
import StackedVarianceChart from '../Charts/NewCharts/StackedVarianceChart';
import ProjectSlippagePercentageChart from '../Charts/NewCharts/ProjectSlippagePercentageChart';
import { fetchApi } from '../utils/fetchApi';


const sampleData = [
  { project: 'APG-RIDES', estimatedHrs: 0.33, actualHrs: 0.33 },
  { project: 'CHDC', estimatedHrs: 29.0, actualHrs: 21.0 },
  { project: 'EMPLOYEE-MONITORING', estimatedHrs: 52.0, actualHrs: 23.25 },
  { project: 'MHADA', estimatedHrs: 38.45, actualHrs: 16.37 },
  { project: 'NMMC', estimatedHrs: 22.0, actualHrs: 18.0 },
  { project: 'Other', estimatedHrs: 9.5, actualHrs: 9.5 }
];

const projectSlippageData = [
  { project: 'APG-RIDES', slippagePct: 0.0 },
  { project: 'CHDC', slippagePct: 4.5 },
  { project: 'EMPLOYEE-MONITORING', slippagePct: 15.2 },
  { project: 'MHADA', slippagePct: 8.0 },
  { project: 'NMMC', slippagePct: 0.0 },
  { project: 'Other', slippagePct: 2.1 }
];

export const AllDashboard = () => {

  const dispatch = useDispatch();

  const userState = useSelector(state => state.loginData.userData);
  const currentDashToggleTab = useSelector((state) => state?.AllTasks?.ActiveDashToggle);

  const EmpId = userState?.empId
  const departmentData = userState.department.map((itm) => {
    return { label: itm.label, value: itm.value };
  });

  const departmentDatas = userState.department.map((itm) => { return itm.label });
  const toggle = [{ name: 'Self Dashboard', value: 'Self Dashboard' }, { name: 'All Dashboard', value: 'All Dashboard' }];

  // ---------------------- STATES & API TOGETHER --------------------------------
  // ---- FILTER States -----
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // All dashboard graph
  const [dept, setDept] = useState([]);
  const [lead, setLead] = useState("")
  const [empList, SetEmpList] = useState("")
  const [resource, setResource] = useState([]);
  const [projectLabel, setProjectLabel] = useState([])
  const [projectWiseSlippage, setProjectWiseSlippage] = useState([])

  // for new charts implementation
  const [riskMatrix, setRiskMatrix] = useState([]);
  const [developerLoadCapacity, setDeveloperLoadCapacity] = useState([]);
  const [reworkRadar, setReworkRadar] = useState([]);
  const [efficiencyTrend, setEfficiencyTrend] = useState([]);
  const [budgetBurnVelocity, setBudgetBurnVelocity] = useState([]);
  const [slippageImpactDepartment, setSlippageImpactDepartment] = useState([]);
  const [crossDepartmentHandoff, setCrossDepartmentHandoff] = useState([]);
  const [qualityIndexTrend, setQualityIndexTrend] = useState([]);
  const [delegationAccuracy, setDelegationAccuracy] = useState([]);
  const [dormantTaskWeight, setDormantTaskWeight] = useState([]);
  const [globalEfficiencyMap, setGlobalEfficiencyMap] = useState([]);
  const [systemBypassRate, setSystemBypassRate] = useState([]);
  const [globalReOpenedCost, setGlobalReOpenedCost] = useState([]);
  const [dataIntegrityWarning, setDataIntegrityWarning] = useState([]);
  const [actionVolumeSystemLoad, setActionVolumeSystemLoad] = useState([]);
  const [globalSlippageOverview, setGlobalSlippageOverview] = useState(null);

  // for cards api
  const [cardApiRes, setCardApiRes] = useState();
  const baseUrl = userState.resourceType === "humanResource"
    ? process.env.REACT_APP_BASE_URL + "/HRDashboard/HRDashboardAPI"
    : process.env.REACT_APP_BASE_URL + "/TLDashboard/teamLeadDashboardAPI";

  const [payload, setPayload] = useState({
    empId: EmpId,
    fromDate: startDate ? startDate : "",
    toDate: endDate ? endDate : "",
    lead: lead.label ? lead.label : "",
    resource: resource.value !== "All" ? resource.value : "",
    taskDepartmentName: dept?.label ? dept?.label : "",
  });

  const totalCardsApis = async () => {
    await axiosApi(baseUrl, payload)
      .then((res) => {
        setCardApiRes(res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    totalCardsApis()
  }, [startDate, endDate, lead, resource, EmpId, dept])

  // get departmentwise TL
  const [teamLeadList, setTeamLeadList] = useState([]);

  const getTLbyDept = async () => {
    const payload = {
      // departmentName:  dept ? dept.label : departmentDatas
      departmentName: dept.label === "All" ? departmentDatas : dept.label,
    };
    await axiosApi(process.env.REACT_APP_BASE_URL + "/department/getDepartmentTL", payload)
      .then((res) => {
        setTeamLeadList(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const leadName = teamLeadList && Array.isArray(teamLeadList)
    ? teamLeadList.map((itm) => {
      return {
        label: itm.teamLeadName,
        value: itm.teamLeadId,
      };
    })
    : [];

  const getEmpByManagerId = async (e) => {
    const payload = {
      empIdTL: lead ? lead.value : EmpId,
    };
    await axiosApi(process.env.REACT_APP_BASE_URL + "/emp/getParticularTlEmployee", payload)
      .then((res) => {
        SetEmpList(res.data.data)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const departmentDataWithAll = [
    { label: "All", value: "All" },
    ...departmentData,
  ];

  // for resource list
  const resourceList = empList
    ? empList
      .filter((itm) => itm.empId !== (lead ? lead.value : ''))
      .map((itm) => ({
        label: `${itm.firstName} ${itm.lastName}`,
        value: itm.empId,
      }))
    : [];
  const resourceData = [
    { label: "All", value: "All" },
    ...resourceList,
  ];


  useEffect(() => {
    setResource("")
    getEmpByManagerId()
  }, [lead])

  useEffect(() => {
    setLead("")
    setResource("")
    getTLbyDept()
  }, [dept]);


  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    setDept("");
    setLead("");
    setResource("");

    setPayload({
      empId: EmpId,
      fromDate: "",
      toDate: "",
      lead: "",
      resource: "",
      taskDepartmentName: "",
    });
  };


  // for new graphs implementation
  const getCommonPayload = (isRiskMatrix = false) => ({
    fromDate: startDate || "",
    toDate: endDate || "",
    department_id: isRiskMatrix ? "" : dept?.value !== "All" ? dept?.value : "",
    subDepartmentId: "",
    resource_id: resource?.value && resource?.value !== "All" ? resource.value : "",
    projectId: "",
    status: "",
    empId: "",
  });

  useEffect(() => {
    getRiskSlippageMatrix();
    getDeveloperLoadCapacity();
    getReworkRadar();
    getEfficiencyTrendline();
    getBudgetBurnVsVelocity();
    getSlippageImpactDepartment();
    getCrossDepartmentHandoff();
    getQualityIndexTrend();
    getDelegationAccuracy();
    getDormantTaskWeight();
    getGlobalEfficiencyMap();
    getSystemBypassRate();
    getGlobalReOpenedCost();
    getDataIntegrityWarning();
    getActionVolumeSystemLoad();
    getGlobalSlippageOverview();
    getProjectWiseEstimatedVsActualTimespentData();
    getProjectWiseSlippage();
  }, [startDate, endDate, dept, lead, resource]);



  const fetchGraphData = async ({ endpoint, setState, defaultValue = [], isRiskMatrix = false, }) => {
    try {
      const payload = getCommonPayload(isRiskMatrix);
      const res = await axiosApi(`${process.env.REACT_APP_BASE_URL}${endpoint}`, payload);
      setState(res?.data?.data || defaultValue);
    } catch (err) {
      console.log(err);
    }
  };


  // for new charts implementation
  const getRiskSlippageMatrix = () =>
    fetchGraphData({
      endpoint: "/graph/riskSlippageMatrix",
      setState: setRiskMatrix,
      defaultValue: [],
      isRiskMatrix: true,
    });

  const getDeveloperLoadCapacity = () =>
    fetchGraphData({
      endpoint: "/graph/developerLoadCapacityGraph",
      setState: setDeveloperLoadCapacity,
      defaultValue: [],
    });

  const getReworkRadar = () =>
    fetchGraphData({
      endpoint: "/graph/reworkRadarGraph",
      setState: setReworkRadar,
      defaultValue: [],
    });

  const getEfficiencyTrendline = () =>
    fetchGraphData({
      endpoint: "/graph/efficiencyTrendline",
      setState: setEfficiencyTrend,
      defaultValue: [],
    });

  const getBudgetBurnVsVelocity = () =>
    fetchGraphData({
      endpoint: "/graph/budgetBurnVsVelocity",
      setState: setBudgetBurnVelocity,
      defaultValue: [],
    });

  const getSlippageImpactDepartment = () =>
    fetchGraphData({
      endpoint: "/graph/slippageImpactByDepartment",
      setState: setSlippageImpactDepartment,
      defaultValue: [],
    });

  const getCrossDepartmentHandoff = () =>
    fetchGraphData({
      endpoint: "/graph/crossDepartmentHandoffDelay",
      setState: setCrossDepartmentHandoff,
      defaultValue: [],
    });

  const getQualityIndexTrend = () =>
    fetchGraphData({
      endpoint: "/graph/qualityIndexQWDTrend",
      setState: setQualityIndexTrend,
      defaultValue: [],
    });

  const getDelegationAccuracy = () =>
    fetchGraphData({
      endpoint: "/graph/delegationAccuracy",
      setState: setDelegationAccuracy,
      defaultValue: [],
    });

  const getDormantTaskWeight = () =>
    fetchGraphData({
      endpoint: "/graph/dormantTaskWeight",
      setState: setDormantTaskWeight,
      defaultValue: [],
    });

  const getGlobalEfficiencyMap = () =>
    fetchGraphData({
      endpoint: "/graph/globalEfficiencyMap",
      setState: setGlobalEfficiencyMap,
      defaultValue: [],
    });

  const getSystemBypassRate = () =>
    fetchGraphData({
      endpoint: "/graph/systemBypassRate",
      setState: setSystemBypassRate,
      defaultValue: [],
    });

  const getGlobalReOpenedCost = () =>
    fetchGraphData({
      endpoint: "/graph/globalReOpenedCost",
      setState: setGlobalReOpenedCost,
      defaultValue: [],
    });

  const getDataIntegrityWarning = () =>
    fetchGraphData({
      endpoint: "/graph/dataIntegrityWarning",
      setState: setDataIntegrityWarning,
      defaultValue: [],
    });

  const getActionVolumeSystemLoad = () =>
    fetchGraphData({
      endpoint: "/graph/actionVolumeSystemLoad",
      setState: setActionVolumeSystemLoad,
      defaultValue: [],
    });

  const getGlobalSlippageOverview = () =>
    fetchGraphData({
      endpoint: "/graph/globalSlippageOverview",
      setState: setGlobalSlippageOverview,
      defaultValue: null,
    });

    const getProjectWiseSlippage = () => 
      fetchGraphData({
        endpoint: "/graph/newprojectWiseSleepage",
        setState: setProjectWiseSlippage,
        defaultValue: null,
      });


  const getProjectWiseEstimatedVsActualTimespentData = () => 
    fetchGraphData({
      endpoint: "/graph/newprojectWiseChartAndTimeTL",
      setState: setProjectLabel,
      defaultValue: null,
    });

  // const getProjectWiseEstimatedVsActualTimespentData = async () => {
  //   try {
  //     const payload = {
  //       "empId": '',
  //       "department_id": dept?.label !== 'All' ? dept.label : "",
  //       "fromDate": startDate ? startDate : "",
  //       "toDate": endDate ? endDate : "",

  //       // "department_id":"",
  //       "subDepartmentId": "",
  //       "resource_id": "",
  //       "projectId": "",
  //       "status": "",
  //     };

  //     const response = await fetchApi(process.env.REACT_APP_BASE_URL + "/graph/newprojectWiseChartAndTimeTL", {
  //       method:'POST',
  //       body: payload
  //     })
  //     const res = await response.json();

  //     setProjectLabel(res.data.map(d => ({
  //       ...d,
  //       actualHrs: Math.floor(Math.random()*10) + 4
  //     })));

  //     // console.log('data : ', res.data)
  //     let projectsArrayData = [];

  //     projectsArrayData.push({
  //       type: "bar",
  //       label: "Actual Hours",
  //       fill: true,
  //       data: res.data,
  //       backgroundColor: "#4E79A7",
  //     });

  //     projectsArrayData.push({
  //       type: "bar",
  //       label: "Estimate Hours",
  //       fill: true,
  //       data: res.data,
  //       backgroundColor: "#F28E2B",
  //     });
  //     setProjectData(projectsArrayData);

  //   } catch (error) {
  //     console.log("Error", "Something went wrong...!")
  //   }
  // }

  return (
    <div className='EmpDash outletPadding' data-aos='fade-up'>
      <Container>
        {userState.resouceType !== "employee" &&
          <Row className='d-flex justify-content-end align-items-center'>
            <Col sm={12} md={12} className='d-flex justify-content-end align-items-center'>
              <ButtonGroup>
                {toggle.map((radio, idx) => (
                  <ToggleButton
                    key={idx}
                    id={`radio-${idx}`}
                    type="radio"
                    variant={idx % 2 ? 'outline-success' : 'outline-danger'}
                    name="radio"
                    value={radio.value}
                    checked={currentDashToggleTab === radio.value}
                    onChange={(e) => { dispatch(setActiveDashToggle(e.currentTarget.value)); }}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
            </Col>
          </Row>}

        {
          currentDashToggleTab === "Self Dashboard"
            ?
            <EmpDash />
            :
            <>
              {userState?.resourceType === "humanResource" && currentDashToggleTab === "All Dashboard" ? <HrAllDashboard /> :
                <>
                  <Row className='justify-content-between w-100 mt-2'>
                    {userState?.resourceType !== "teamlead" && <>
                      <Col className='mb-4 mb-md-0'>
                        <Form.Group>
                          <Form.Label> Department </Form.Label>
                          <Select
                            isMulti={false}
                            isSearchable={true}
                            value={dept}
                            options={departmentDataWithAll}
                            onChange={(selectedOption) => {
                              if (selectedOption && selectedOption.value === "All") {
                                setDept(selectedOption);
                                setLead("");
                                setResource("");
                                // Set the 'taskDepartmentName' in the 'payload' to an empty string when "All" is selected
                                setPayload((prevPayload) => ({ ...prevPayload, taskDepartmentName: "", lead: "", resource: "" }));
                              } else {
                                setDept(selectedOption);
                                setLead("");
                                setResource("");
                                // Set the 'taskDepartmentName' in the 'payload' to the selected department label
                                setPayload((prevPayload) => ({ ...prevPayload, taskDepartmentName: selectedOption.label }));
                              }

                              totalCardsApis();
                            }}
                          />
                        </Form.Group>
                      </Col>

                      <Col className='mb-4 mb-md-0'>
                        <Form.Group>
                          <Form.Label> Lead/Manager </Form.Label>
                          <Select
                            isMulti={false}
                            isSearchable={true}
                            value={lead}
                            options={leadName}
                            onChange={(selectedOption) => { setPayload((prevPayload) => ({ ...prevPayload, lead: selectedOption.label })); setLead(selectedOption); setResource("") }}
                          />
                        </Form.Group>
                      </Col>
                    </>
                    }
                    <Col className='mb-4 mb-md-0'>
                      <Form.Group>
                        <Form.Label>Resource</Form.Label>
                        <Select
                          isMulti={false}
                          isSearchable={true}
                          value={resource}
                          options={userState?.resourceType === "teamlead" ? resourceData : lead ? resourceData : []}
                          onChange={(selectedOption) => {
                            if (selectedOption && selectedOption.value === "All") {
                              setResource(selectedOption);
                              // setPayload((prevPayload) => ({ ...prevPayload, resource: selectedOption.value !== "All"? selectedOption.value : " " }));
                              setPayload((prevPayload) => ({ ...prevPayload, resource: "" }));
                              totalCardsApis();
                            }
                            else {
                              setResource(selectedOption);
                              setPayload((prevPayload) => ({ ...prevPayload, resource: selectedOption.value }));
                              totalCardsApis();
                            }

                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={5} className='d-flex justify-content-end mt-0 mt-md-0'>
                      <Row className='w-100 align-items-end'>
                        <Col md={5} sm={12} className='ps-0 mb-2 mb-md-0'>
                          <Form.Group>
                            <Form.Label>From</Form.Label>

                            <Form.Control
                              type="date"
                              value={startDate}
                              onChange={(e) => {
                                setStartDate(e.target.value)
                                setEndDate("")
                              }}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={5} sm={12} className='ps-0 mb-2 mb-md-0'>
                          <Form.Group>
                            <Form.Label>To</Form.Label>

                            <Form.Control
                              type="date"
                              value={endDate}
                              min={startDate}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </Form.Group>
                        </Col>

                        <Col md={2} sm={12} className='ps-0'>
                          <Button
                            className="clearBtn"
                            onClick={handleClear}
                          >
                            Clear
                          </Button>
                        </Col>

                      </Row>
                    </Col>
                  </Row>

                  <DashCards
                    totalPro={cardApiRes?.totalProjects || 0}
                    totalEst={cardApiRes?.totalEstimateHrs?.toFixed(2) || 0}
                    totalActTime={cardApiRes?.totalActualHrs?.toFixed(2) || 0}
                    slippage={cardApiRes?.slippage?.toFixed(2) || 0}
                    totalTask={cardApiRes?.totalTasks || 0}
                    efficiency={cardApiRes?.efficiency?.toFixed(2) || 0}
                    totalPendingTask={cardApiRes?.totalPendingTask || 0}
                    totalCompTask={cardApiRes?.totalCompletedTask || 0}
                    avgQWD={isNaN(Number(cardApiRes?.avgQWD)) ? 0 : Number(cardApiRes?.avgQWD)?.toFixed(2) || 0}
                    avgIDC={isNaN(Number(cardApiRes?.avgIDC)) ? 0 : Number(cardApiRes?.avgIDC)?.toFixed(2) || 0}
                  />

                  {/* for new charts implementation */}

                  <div className="analyticsWrapper">
                    <div className="analyticsHeader">
                      <h3>Analytics</h3>
                      <p>Charts & Visualizations</p>
                    </div>

                    <div className="dashboardGraphs">
                      <Row className="g-4">
                        {/* Project Efficiency */}
                        <Col sm={12}>
                          <StackedVarianceChart
                            xAxisTitle='Hours'
                            yAxisTitle='Projects'
                            label="project"
                            value1="estimatedHrs"    // Total Estimated Hours
                            value2="actualHrs"      // Actual Hours Spent
                            chartData={projectLabel}
                            chartHeight="450px"
                            chartHeading="Project Efficiency: Estimated vs. Actual Time Variance (Hrs)"
                          />
                        </Col>

                        {/* Project wise Slippage */}
                        <Col sm={12}>
                          <ProjectSlippagePercentageChart
                            yAxisTitle='Slippage (%)'
                            xAxisTitle='Projects'
                            label="project"
                            slippageKey="slippagePct"
                            chartData={projectWiseSlippage}
                            chartHeight="650px"
                            chartHeading="Projects Health: Average Slippage (%)"
                          />
                        </Col>
                      </Row>
                    </div>

                    {/* for team lead */}
                    {userState?.resourceType === "teamlead" &&
                      <div className="dashboardGraphs">
                        <Row className="g-4">

                          {/* {riskMatrix?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <ScatterChart
                                chartLabel="Tasks at Risk"
                                chartData={riskMatrix}
                                purpose="Highlights tasks that are high priority"
                                xField="slippage"
                                yField="priorityValue"
                                colorField="taskPriority"
                                xAxisTitle="Slippage"
                                yAxisTitle="Task Priority"
                                yAxisMin={1}
                                yAxisMax={4}
                                yAxisInterval={1}
                                yAxisFormatter={(value) => {
                                  switch (value) {
                                    case 1:
                                      return "Low";
                                    case 2:
                                      return "Medium";
                                    case 3:
                                      return "High";
                                    case 4:
                                      return "Urgent";
                                    default:
                                      return value;
                                  }
                                }}
                                tooltipFields={[
                                  { key: "taskName", label: "Task" },
                                  { key: "resourceName", label: "Resource" },
                                  { key: "taskPriority", label: "Priority" },
                                  { key: "status", label: "Status" },
                                ]}
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          {/* {developerLoadCapacity?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <StackerChart
                                completedLabel="Active Work"
                                pendingLabel="Pending Work"
                                showXAxisLabel={true}
                                chartData={developerLoadCapacity}
                                chartLabel="Team Workload"
                                purpose="Shows hours of active work vs pending work assigned."
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          {/* {reworkRadar?.length > 0 && ( */}
                          <Col lg={12}>
                            <div className="graphCard fullGraphCard">
                              <BarChart
                                chartLabel="Tasks Sent Back for Rework"
                                chartData={reworkRadar}
                                xField="resourceName"
                                yField="reopenCount"
                                yAxisTitle="Reopen Count"
                                xAxisTitle="Employees"
                                purpose="Tracks how many tasks are bounced back from developer."
                                seriesLabel="Reopen Count"
                                tooltipFields={[
                                  {
                                    key: "reopenCount",
                                    label: "Reopen Count",
                                  },
                                  {
                                    key: "totalTasks",
                                    label: "Total Tasks",
                                  },
                                ]}
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          {/* {efficiencyTrend?.length > 0 && ( */}
                          <Col lg={12}>
                            <div className="graphCard fullGraphCard">
                              <LineChart
                                chartLabel="Team Productivity Trend"
                                chartData={efficiencyTrend}
                                xField="date"
                                yField="avgEfficiency"
                                isDate={true}
                                xAxisTitle="Date"
                                yAxisTitle="Average Efficiency"
                                seriesLabel="Average Efficiency"
                                purpose="Monitors the overall velocity and output quality."
                                tooltipFields={[
                                  {
                                    key: "totalTasks",
                                    label: "Total Tasks",
                                  },
                                ]}
                              />
                            </div>
                          </Col>
                          {/* )} */}

                        </Row>
                      </div>
                    }

                    {/* for manager */}
                    {userState?.resourceType === "manager" &&
                      <div className="dashboardGraphs">
                        <Row className="g-4">
                          {/* {budgetBurnVelocity?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <ComboChart
                                chartData={budgetBurnVelocity}
                                chartLabel="Estimated vs Actual Work Hours"
                                xField="resourceName"
                                barField="totalActualHrs"
                                lineField="totalEstimateHrs"
                                xAxisTitle="Employees"
                                leftAxisTitle="Actual Hours"
                                rightAxisTitle="Estimate Hours"
                                barLabel="Actual Hours"
                                lineLabel="Estimate Hours"
                                fieldsLabel="totalActualHrs (Bar) vs totalEstimateHrs (Line)"
                                purpose="Compares actual hours logged against estimated hours per project."
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          {/* {slippageImpactDepartment?.length > 0 && ( */}
                          {/* <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <RaddarChart
                                chartData={slippageImpactDepartment}
                                chartLabel="Slippage Impact by SubDepartment"
                                fieldsLabel=""
                                purpose="Identifies which department is consistently missing deadlines."
                                legendLabel="Average Slippage"
                              />
                            </div>
                          </Col> */}
                          {/* )} */}

                          {/* {crossDepartmentHandoff?.length > 0 && ( */}
                          {/* <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <SankeyChart
                                chartLabel="Cross-Team Delays"
                                chartData={crossDepartmentHandoff}
                                fieldsLabel=""
                                purpose="Spots bottlenecks where one department waits on another."
                                legendLabel="Department Flow"
                              />
                            </div>
                          </Col> */}
                          {/* )} */}

                          {/* {qualityIndexTrend?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <LineChart
                                chartLabel="Work Quality Trend"
                                chartData={qualityIndexTrend}
                                xField="week"
                                yField="avgQWD"
                                isDate={false}
                                xAxisTitle="Week"
                                yAxisTitle="Average QWD"
                                seriesLabel="Average QWD"
                                purpose="Spots bottlenecks where one dept waits on another."
                                tooltipFields={[
                                  {
                                    key: "totalTasks",
                                    label: "Total Tasks",
                                  },
                                ]}
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          {/* {delegationAccuracy?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <BarChart
                                chartLabel="Task Reassignment Analysis"
                                chartData={delegationAccuracy}
                                xField="assignBy_Name"
                                yField="reassignedTasks"
                                yAxisTitle="Reassigned Tasks"
                                xAxisTitle='Employees'
                                purpose="Identifies if leads are constantly assigning tasks to the wrong people."
                                seriesLabel="Reassigned Tasks"
                                tooltipFields={[
                                  {
                                    key: "reassignedTasks",
                                    label: "Reassigned Tasks",
                                  },
                                  {
                                    key: "totalEstimateHours",
                                    label: "Estimate Hours",
                                  },
                                ]}
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          {/* {dormantTaskWeight?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <TreeMapChart
                                chartLabel="Dormant Tasks By Project"
                                chartData={dormantTaskWeight}
                                fieldsLabel=""
                                purpose="A task is considered dormant if it has not been updated for more than 7 days and is still not completed"
                                legendLabel="Dormant Tasks"
                              />
                            </div>
                          </Col>
                          {/* )} */}
                        </Row>
                      </div>
                    }

                    {/* For Admin */}
                    {userState?.resourceType === "admin" &&
                      <div className="dashboardGraphs">
                        <Row className="g-4">
                          {/* {globalEfficiencyMap?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <HeatMapChart
                                xAxisTitle='Project Name'
                                yAxisTitle='Department Name'
                                chartLabel="Department Performance Overview"
                                fieldsLabel="efficiency scores by departmentName × projectName"
                                chartData={globalEfficiencyMap}
                                purpose="Provides a global view of underperforming sectors."
                                legendLabel="Heat Score"
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          {/* {systemBypassRate?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <BarChart
                                chartLabel="Deleted Tasks by Department"
                                chartData={systemBypassRate}
                                xField="departmentName"
                                yField="bypassRate"
                                fieldsLabel=""
                                yAxisTitle="Bypass Rate (%)"
                                xAxisTitle='Departments'
                                rotateLabel={20}
                                purpose=": High deletion rates mean users are making mistakes."
                                seriesLabel="Bypass Rate (%)"
                                tooltipFields={[
                                  {
                                    key: "deletedTasks",
                                    label: "Deleted Tasks",
                                  },
                                  {
                                    key: "totalTasks",
                                    label: "Total Tasks",
                                  },
                                  {
                                    key: "bypassRate",
                                    label: "Bypass Rate (%)",
                                  },
                                ]}
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          {/* {globalReOpenedCost?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <AreaChart
                                chartLabel="Global Reopened Tasks"
                                chartData={globalReOpenedCost}
                                fieldsLabel="Cumulative actualHours on isReopened: true"
                                purpose=" Quantifies the financial cost of bugs and poor requirements"
                                legendLabel="Cumulative ActualHours"
                                xField="date"
                                yField="cumulativeActualHours"
                                xAxisTitle='Date'
                                yAxisTitle='Reopen Task'
                                tooltipFields={[
                                  {
                                    key: "totalActualHours",
                                    label: "Actual Hours",
                                  },
                                  {
                                    key: "cumulativeActualHours",
                                    label: "Cumulative Hours",
                                  },
                                  {
                                    key: "totalReopenedTasks",
                                    label: "Re-opened Tasks",
                                  },
                                  // {
                                  //   key: "reopenCount",
                                  //   label: "Re-open Count",
                                  // },
                                ]}
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          {/* {dataIntegrityWarning?.length > 0 && ( */}
                          {/* <Col lg={12} md={12} sm={12}>
                              <div className="graphCard">
                                <HorizontalBarChart
                                  chartLabel="Missing Task Information"
                                  chartData={dataIntegrityWarning}
                                  xField="dirtyRecords"
                                  yField="departmentName"
                                  fieldsLabel=""
                                  barColor="#7C4DFF"
                                  purpose="Identifies which teams are generating dirty data."
                                  legendLabel="Task Name"
                                  tooltipFields={[
                                    {
                                      key: "dirtyRecords",
                                      label: "Dirty Records",
                                    },
                                    {
                                      key: "missingEstimate",
                                      label: "Missing Estimate",
                                    },
                                    {
                                      key: "missingDepartment",
                                      label: "Missing Department",
                                    },
                                    {
                                      key: "missingResource",
                                      label: "Missing Resource",
                                    },
                                    {
                                      key: "missingTaskName",
                                      label: "Missing Task Name",
                                    },
                                    {
                                      key: "integrityPercentage",
                                      label: "Integrity %",
                                    },
                                    {
                                      key: "totalTasks",
                                      label: "Total Tasks",
                                    },
                                  ]}
                                />
                              </div>
                            </Col> */}
                          {/* )} */}

                          {/* {actionVolumeSystemLoad?.length > 0 && ( */}
                          {/* <Col lg={12} md={12} sm={12}>
                              <div className="graphCard">
                                <LineChart
                                  chartLabel="Action Volume / System Load"
                                  chartData={actionVolumeSystemLoad}
                                  fieldsLabel="Frequency of taskActionLog events per hour"
                                  xField="date"
                                  yField="totalEvents"
                                  isDate={true}
                                  xAxisTitle="Date"
                                  yAxisTitle="Events"
                                  seriesLabel="Events"
                                  purpose=" Identifies peak database interaction times"
                                  tooltipFields={[
                                    {
                                      key: "startEvents",
                                      label: "Start Events",
                                    },
                                    {
                                      key: "endEvents",
                                      label: "End Events",
                                    },
                                    {
                                      key: "pauseEvents",
                                      label: "Pause Events",
                                    },
                                    {
                                      key: "resumeEvents",
                                      label: "Resume Events",
                                    },
                                    {
                                      key: "progressEvents",
                                      label: "Progress Events",
                                    },
                                    {
                                      key: "assignEvents",
                                      label: "Assign Events",
                                    },
                                    {
                                      key: "reopenEvents",
                                      label: "Re-open Events",
                                    },
                                    {
                                      key: "totalEvents",
                                      label: "Total Events",
                                    },
                                  ]}
                                />
                              </div>
                            </Col> */}
                          {/* )} */}

                          {/* {slippageImpactDepartment?.length > 0 && ( */}
                          <Col lg={12} md={12} sm={12}>
                            <div className="graphCard">
                              <RaddarChart
                                chartData={slippageImpactDepartment}
                                chartLabel="Slippage Impact by Department"
                                fieldsLabel=""
                                purpose="Identifies which department is consistently missing deadlines."
                                legendLabel="Average Slippage"
                              />
                            </div>
                          </Col>
                          {/* )} */}

                          <Col lg={6} md={6} sm={12}>
                            <div className="graphCard">
                              <GaugeChart
                                chartLabel="Overall Project Health"
                                chartData={globalSlippageOverview}
                                fieldsLabel="Total company slippage vs projected hours"
                                valueField="efficiency"
                                statusField="gaugeStatus"
                                showValue={false}
                                showStatus={true}
                                purpose="Macro health check of organizational delivery."
                                gaugeLabel="Efficiency"
                                tooltipFields={[
                                  {
                                    key: "totalTasks",
                                    label: "Total Tasks",
                                  },
                                  {
                                    key: "totalEstimateHours",
                                    label: "Estimate Hours",
                                  },
                                  {
                                    key: "totalActualHours",
                                    label: "Actual Hours",
                                  },
                                  {
                                    key: "slippage",
                                    label: "Slippage (%)",
                                  },
                                  {
                                    key: "efficiency",
                                    label: "Efficiency (%)",
                                  },
                                ]}
                                progressColor="#19B885"
                                backgroundColor="#E8EDF5"
                                pointerColor="#1E293B"
                                gaugeWidth={20}
                                pointerWidth={5}
                                pointerLength="62%"
                                radius="72%"
                                center={["50%", "72%"]}
                                startAngle={200}
                                endAngle={-20}
                                min={0}
                                max={100}
                                height={260}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    }
                  </div>

                </>
              }

            </>
        }
      </Container>
    </div>
  )
}
